import React from "react";
import Chip from "@mui/material/Chip";
import { formatPublisherStatusColour } from "./formatting";
import { formatPublisherStatus } from "@seabrookstudios/pitch2table-core";

export const PublisherStatus = ({ status }) => (
  <Chip label={formatPublisherStatus(status)} color={formatPublisherStatusColour(status)} />
);
